"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemovePhone = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var pp_react_1 = require("@paypalcorp/pp-react");
var constants_1 = require("../../../constants");
var phones_1 = require("../../../actions/phones");
var commonweb_utils_1 = require("commonweb-utils");
var commonUtils_1 = require("../../../common/utils/commonUtils");
var icons_component_1 = require("../../../components/icons.component");
var interpolate_component_1 = require("../../../components/interpolate-component");
var ajax_util_1 = require("../../../utils/ajax/ajax.util");
var ErrorContentMapper_1 = require("../../../utils/errorcodes/ErrorContentMapper");
var utils_1 = require("../../../common/utils/phones/utils");
var triggerOperationResult_1 = require("../../../utils/fpti/triggerOperationResult");
var beaver_logger_1 = require("../../../utils/logging/beaver-logger");
var constants_2 = require("./constants");
var page = require("page");
var RemovePhone = /** @class */ (function (_super) {
    tslib_1.__extends(RemovePhone, _super);
    function RemovePhone(props) {
        var _this = _super.call(this, props) || this;
        _this.submitHandler = function (event) {
            event.preventDefault();
            _this.setState({ showSpinner: true });
            var formData = {};
            formData["id"] = _this.state.id;
            /* Set isTcpaEnabled & isSCAEnabled to false to avoid unnecessary call to getTCPA as delete phone
            will not have any impact on TCPA prefs and these will remain unchanged.*/
            formData["isTcpaEnabled"] = false;
            formData["isSCAEnabled"] = false;
            ajax_util_1.default.post$(_this.props.dispatch, _this.props._csrf, "" + constants_1.default.ROUTES.API.PHONES.REMOVE, formData, { component: { name: constants_1.default.VIEWS.PHONES.DELETE } })
                .then(function (phoneInfo) {
                _this.props.dispatchPhoneDeletion(phoneInfo);
                _this.props.performedAction(constants_1.default.VIEWS.PHONES.TOAST_INTENTS.REMOVE);
                _this.setState({ showSpinner: false });
                page.redirect(constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.PHONES.MANAGE);
            })
                .catch(function (error) {
                var errorMessage = ErrorContentMapper_1.getPhoneErrorContent(error, _this.props.content);
                beaver_logger_1.default().info(constants_2.PHONE.DELETE_PHONE, {
                    message: errorMessage,
                });
                triggerOperationResult_1.triggerOperationResult(_this.props.phoneFpti.makePrimary, constants_1.default.FPTI.FAILURE, errorMessage);
                if (errorMessage.includes("stepupContext")) {
                    var url = window.origin.concat(errorMessage);
                    window.location.assign(url);
                }
                else {
                    _this.setState({
                        errorMessage: errorMessage,
                        showSpinner: false,
                    });
                }
                return;
            });
        };
        var removePhoneId = _this.props.route.enter.params.id, phonesList = _this.props.phones, phoneToRemove = commonUtils_1.findObjectInListById(phonesList, removePhoneId);
        if (phoneToRemove) {
            _this.phoneNumberToRemove = phoneToRemove.maskedSubscriberNumber;
        }
        _this.state = {
            id: commonweb_utils_1.objectUtils.safeGet(_this.props, "route.enter.params.id") || "",
            errorMessage: "",
            showSpinner: false,
        };
        return _this;
    }
    RemovePhone.prototype.render = function () {
        var phoneContent = this.props.content.phones, commonContent = this.props.content.common, phoneNumber = this.phoneNumberToRemove;
        var removeConfirmationMessage = interpolate_component_1.InterpolateLinksWithComponent(phoneContent.remove.alert.message, [phoneNumber]);
        return (React.createElement("div", { className: "generic-container" },
            this.state.errorMessage ? (React.createElement(pp_react_1.Alert, { type: "error", className: "alignLeft nameAlert" }, this.state.errorMessage)) : null,
            React.createElement(icons_component_1.IllustrationComponent, { modifierClass: "successImg", image: "Warning" }),
            React.createElement(pp_react_1.Text, { size: "xl3", className: "phoneConfirm-header" }, phoneContent.remove.alert.title),
            React.createElement(pp_react_1.Text, { size: "md", className: "infoPages-description" }, removeConfirmationMessage),
            React.createElement(pp_react_1.Button, { className: "infoPages-btn test_removeButton", onClick: this.submitHandler, "data-name": this.props.phoneFpti.submitRemove }, this.state.showSpinner ? (React.createElement(pp_react_1.LoadingSpinner, { className: "loading-spinner", screenReaderText: "loading", inverse: true })) : (React.createElement(pp_react_1.Text, { size: "md", className: "ok-button" }, commonContent.remove)))));
    };
    return RemovePhone;
}(React.Component));
exports.RemovePhone = RemovePhone;
var mapStateToProps = function (_a) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, features = _a.features, account = _a.account, fpti = _a.fpti;
    var phones = commonweb_utils_1.objectUtils.safeGet(account, "phones.phones") || {}, phoneFpti = fpti.phones;
    phones = utils_1.changeNumberFormatForNonSCARegions(phones, utils_1.isSCAEnabled(features));
    return {
        _csrf: _csrf,
        ui: ui,
        content: content,
        route: route,
        phones: phones,
        phoneFpti: phoneFpti,
    };
};
function mapDispatchToProps(dispatch) {
    return {
        dispatchPhoneDeletion: function (phones) { return dispatch(phones_1.changePhone(phones)); },
        performedAction: function (typeOfAction) {
            return dispatch(phones_1.actionClicked(typeOfAction));
        },
        dispatch: dispatch,
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(RemovePhone);
